export const icons = {
    '03':{
        icon:'icon-shipin1',
        text:'视频'
    },
    '05':{
        icon:'icon-tupian',
        text:'图片'
    },
    '06':{
        icon:'icon-tupian',
        text:'表格'
    },
    '07':{
        icon:'icon-zuoye-xuanzhong',
        text:'作业'
    },
    '02':{
        icon:'icon-tupian',
        text:'文档'
    },
    '01':{
        icon:'icon-music',
        text:'文本'
    },
    '04':{
        icon:'icon-music',
        text:'音频'
    }
}
export  const exercises={

    40:{
        title:"题干"
    },
    10:{
        title:"单选题"
    },
    20:{
        title:"多选题"
    },
    30:{
        title:"判断题"
    },
    70:{
        title:"阅读"
    },
    71:{
        title:"填空"
    },
    62:{
        title:"名词解释"
    },
    63:{
        title:"问答"
    },
    64:{
        title:"论述"
    },

    65:{
        title:"完形填空"
    },
    66:{
        title:"计算"
    },
    67:{
        title:"作文"
    }
}
